// extracted by mini-css-extract-plugin
module.exports = {"part3":"part3_part3__39WFy","inner":"part3_inner__3737a","left":"part3_left__3Y49i","right":"part3_right__2EHS_"};